import React from 'react';



import Banner from './Banner';

const Home = () => {
    return (
        <div className="min-h-screen py-6 px-12">
            <Banner></Banner>
           

        
            
           
        </div>
    );
};

export default Home;